/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import "./footer.scss";

function Footer() {
    let dateObj = new Date();
   
    return (
        <div className="footer d-flex">
            <div className="row footer-row">
                <div><a className="footer-link" href="https://login.pearson.com/v1/piapi/policies/static/html/ALSecondaryPearsonEULA.html?" target="_blank">Terms of use</a></div>
                <div className="footer-separator"></div>
                <div><a className="footer-link" href="https://support.pearson.com/uk/s/digital-contactus" target="_blank">Contact us</a></div>
                <div className="footer-separator"></div>
                <div><a className="footer-link" href="https://www.pearson.com/uk/pearson-privacy-and-you/cookie-policy.html" target="_blank">Cookie policy</a></div>
                <div className="footer-separator"></div>
                <div><a className="footer-link" href="https://loginstatic.pearson.com/html/EU/PearsonPrivacyPolicy_en_GB.html?cc=GB&lang=en_GB" target="_blank">Privacy notice</a></div>
                <div className="footer-separator"></div>
                <div><a className="footer-link" href="https://www.pearson.com/uk/accessibility.html" target="_blank">Accessibility</a></div>
                {/* <div className="footer-separator"></div>
                <div><a className="footer-link" href="pearson.com/uk/pearson-privacy-and-you/privacy-policy/digital-learning-services-privacy-policy">Privacy</a></div> */}
                <div className="footer-separator"></div>
                <div><a className="footer-link" href=" https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN" target="_blank">Online dispute resolution</a></div>
                <div className="footer-separator"></div>
                <div><a className="footer-link" href=" https://www.pearsonschoolsandfecolleges.co.uk/DigitalSupport/Secondary/ALDS_HelpArea/Releases-and-updates/activelearn-secondary-purchase-terms-and-conditions.aspx" target="_blank">Terms and conditions</a></div>
                <div className="footer-separator"></div>
                <div><a className="footer-link">&#169; Pearson Education Ltd {dateObj.getFullYear()}</a></div>
            </div>
        </div>
    )
}

export default Footer
